import { createSlice } from '@reduxjs/toolkit';
import { FinancialProductType } from '../../../resources/base/models/enums';

const initialState = {
  selectedProductType: FinancialProductType.FINANCING,
};

export const productFamilySlice = createSlice({
  name: 'productFamily',
  initialState,
  reducers: {
    resetProductType() {
      return initialState;
    },
  },
});

export const brokerSelectors = productFamilySlice.selectors;
export const { resetProductType } = productFamilySlice.actions;
export const productFamilyReducer = productFamilySlice.reducer;
